import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=0f6fb44a&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=0f6fb44a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6fb44a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f6fb44a')) {
      api.createRecord('0f6fb44a', component.options)
    } else {
      api.reload('0f6fb44a', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=0f6fb44a&scoped=true&", function () {
      api.rerender('0f6fb44a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-49pmXpk2rXZLV/JS/comp/GuestBox.vue"
export default component.exports